/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapPinUp = createReactComponent("map-pin-up", "IconMapPinUp", [
  ["path", { d: "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M12.789 21.324a2 2 0 0 1 -2.202 -.424l-4.244 -4.243a8 8 0 1 1 13.59 -4.626",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 22v-6", key: "svg-2" }],
  ["path", { d: "M22 19l-3 -3l-3 3", key: "svg-3" }]
]);

export { IconMapPinUp as default };
//# sourceMappingURL=IconMapPinUp.js.map
